document.addEventListener('DOMContentLoaded', function() {
  const swiper = new Swiper('.section--swiper ', {
    slidesPerView: 2.2,
    speed: 400,
    direction: 'horizontal',
    loop: false,
    spaceBetween: 4,
    // Navigation arrows
    navigation: {
      nextEl: '.section--swiper .slider-button--next',
      prevEl: '.section--swiper .slider-button--prev'
    },
    pagination: {
      el: '.section--swiper .swiper-pagination',
      clickable:true,
    },
    // And if we need scrollbar
    scrollbar: {
      el: '.section--swiper .slider-scrollbar',
      draggable: true,
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
        spaceBetween: 0,
      },
      580: {
        slidesPerView: 2.5,
        spaceBetween: 24,

      }
    }
  });
  if(document.querySelector('.slider-product-list')){
    let max_slide = document.querySelector('.slider-product-list .swiper-wrapper').getAttribute('data-qty');
    const swiper = new Swiper('.slider-product-list .swiper', {
      slidesPerView: 2.2,
      speed: 400,
      direction: 'horizontal',
      loop: false,
      spaceBetween: 4,
      // Navigation arrows
      navigation: {
        nextEl: '.slider-product-list .slider-button--next',
        prevEl: '.slider-product-list .slider-button--prev'
      },
      pagination: {
        el: '.slider-product-list .swiper-pagination',
        clickable:true,
      },
      // And if we need scrollbar
      scrollbar: {
        el: '.slider-product-list .slider-scrollbar',
        draggable: true,
      },
      breakpoints: {
        992: {
          slidesPerView: max_slide,
          spaceBetween: 0,
        },
        580: {
          slidesPerView: 2.5,
          spaceBetween: 24,

        }
      }
    });
  }
  if(document.querySelector('.testimonials-swiper')){
    const testimonials_swiper = new Swiper('.testimonials-swiper', {
      slidesPerView: 1,
      slidesPerGroup: 1,
      speed: 400,
      loop: false,
      centeredSlides: false,
      spaceBetween: 4,
      // Navigation arrows
      navigation: {
        nextEl: '.slider-button--next',
        prevEl: '.slider-button--prev'
      },
      breakpoints: {
        1300: {
          slidesPerView: 4,
          slidesPerGroup: 4,
          spaceBetween: 4,
        },
        992: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 4,
        },
        580: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 4,
        }
      }
    });
  }
});